import { render, staticRenderFns } from "./LessonPackage.vue?vue&type=template&id=3a95dc43&scoped=true"
import script from "./LessonPackage.vue?vue&type=script&lang=js"
export * from "./LessonPackage.vue?vue&type=script&lang=js"
import style0 from "./LessonPackage.vue?vue&type=style&index=0&id=3a95dc43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a95dc43",
  null
  
)

export default component.exports